<!--
 * @Author: Gaho
 * @Date: 2024-02-26 13:46:41
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-21 17:10:53
 * @Description: 
-->
<template>
    <div class="card-bg">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            class="background-gradient"
            viewBox="0 0 161 159"
        >
            <rect width="161" height="159" fill="#5638B2" fill-opacity=".45" rx="14"></rect>
            <g>
                <circle cx="50%" cy="50%" r="64" fill="currentColor" filter="url(#abc)"></circle>
            </g>
            <defs>
                <filter
                    id="abc"
                    width="159.635"
                    height="158.222"
                    x=".6825"
                    y=".6825"
                    color-interpolation-filters="sRGB"
                    filterUnits="userSpaceOnUse"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
                    <feGaussianBlur stdDeviation="17.6587"></feGaussianBlur>
                </filter>
            </defs>
        </svg>
        <img src="@/assets/imgs/casino/corgiwild/7.webp" class="card-bg-img" alt="" />
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'corgiwild-card-7',
});
</script>
<style lang="scss" scoped>
.background-gradient {
    color: #ffa113d1 !important;
}
</style>